import './CardCommon.css';

export default function CardInverter({ data, onClick }) {
    const getInverterIcon = (data) => {
        const value = data?.connection_logger;
        if (value === undefined || value === null) {
            return <h5 className="card-title font-weight-bold mb-0"> {data.inverter_id_text} <span className='tagalarm alarming'>Unknown Logger State</span> {getFaultIcon(data)} {getShutdownIcon(data)} {getPLimitIcon(data)}</h5>
        }

        if (data.connection_logger === true) {
            if (data.connection_device === true) {
                return <h5 className="card-title font-weight-bold mb-0"> {data.inverter_id_text} <span className='tagalarm normal'>Online</span> {getFaultIcon(data)} {getShutdownIcon(data)} {getPLimitIcon(data)} {getSN_Alert(data)}</h5>
            }
            return <h5 className="card-title font-weight-bold mb-0"> {data.inverter_id_text} <span className='tagalarm alarming'>Device Offline</span> {getFaultIcon(data)} {getShutdownIcon(data)} {getPLimitIcon(data)}</h5>
        }
        return <h5 className="card-title font-weight-bold mb-0"> {data.inverter_id_text} <span className='tagalarm alarming'>Logger Offline</span> {getFaultIcon(data)} {getShutdownIcon(data)} {getPLimitIcon(data)}</h5>
    }

    const getFaultIcon = (data) => {
        const value = data?.fault_code_text;
        if (value === undefined || value === null) {
            return null
        }
        if (data.fault_code !== 0 || (data.fault_code_text !== "0" && data.fault_code_text !== "")) {
            return <span className='tagalarm alarming'>Fault</span>
        }
        return null
    }

    const getShutdownIcon = (data) => {
        const value = data?.is_run_shutdown;
        if (value === undefined || value === null) {
            return null
        }
        if (!data.is_run_shutdown) {
            return <span className='tagalarm alarming'>Shutdown</span>
        }
        return null
    }

    const getPLimitIcon = (data) => {
        const value = data?.inverter_state;
        if (value === undefined || value === null) {
            return null
        }
        if (data.inverter_state === 513) {
            return <span className='tagalarm warning-orange'>P Limit</span>
        }
        return null
    }

    const ReadTags = (data, digit) => {
        const value = data;
        if (value === undefined || value === null) {
            return "-"
        }
        return data.toFixed(digit)
    }

    const ReadTags_Thounsand = (data, digit) => {
        const value = data;
        if (value === undefined || value === null) {
            return "-"
        }
        return data.toLocaleString('en-US', { minimumFractionDigits: digit, maximumFractionDigits: digit })
    }

    const ReadTags_String = (data) => {
        const value = data;
        if (value === undefined || value === null) {
            return "Update : -"
        }
        return "Update : " + data
    }

    const GetFaultCodeUI = (data) => {
        const value = data;
        if (value === undefined || value === null) {
            return null
        }
        if (data > 0) {
            return <div className='alarm-flags alarming'>F</div>
        }
        return null
    }

    const ReadTags_SerialNo = (data) => {
        const value = data;
        if (value === undefined || value === null) {
            return null
        }
        if (data.serial_no !== undefined && data.serial_no !== "") {
            return <h6 className="update-time mt-0 mb-0">Serial No. : {data.serial_no}</h6>
        } else {
            return <h6 className="update-time mt-0 mb-0">Serial No. :</h6>
        }
    }

    const ReadTags_SerialNoSubSystem = (data) => {
        const value = data?.meter_sn;
        if (value === undefined || value === null) {
            return null
        }
        if (data.meter_sn === "") {
            return null
        }
        if (data.subsystem !== undefined && data.subsystem !== "") {
            return <p className="update-time mt-0 mb-0">Meter S/N. : {data.meter_sn}, {data.subsystem}</p>
        } else {
            return <p className="update-time mt-0 mb-0">Meter S/N. : {data.meter_sn}</p>
        }
    }

    const getSN_Alert = (data) => {
        const value = data?.connection_device;
        if (value === undefined || value === null) {
            return null
        }
        if (data.connection_device === true && data.connection_logger === true && data.serial_ok === false) {
            return <span className='tagalarm alarming'>SN</span>
        }
        return null
    }

    return (
        <div className="card card-common card-inverter">
            <div className="card-body d-flex flex-row pb-1 inverter-header">
                <div className='d-block'>
                    <div className="d-flex mt-0 mb-0">
                        {getInverterIcon(data)}
                    </div>
                    {ReadTags_SerialNo(data)}
                    {ReadTags_SerialNoSubSystem(data)}
                    <p className="update-time mt-0 mb-0">{ReadTags_String(data.update_time)}</p>
                </div>
            </div>

            <div className="card-body pb-2 pt-0 pr-0" onClick={() => onClick(data.inverter_id_text)}>
                <div className="row">
                    <div className="col-md-12 mb-0">
                        <div className="measure-table font-poppins">
                            <div className="measure-rows font-bold measure-header">
                                <div className="measure-cell border-bottom px-2">Parameter</div>
                                <div className="measure-cell numberright border-bottom">Value</div>
                                <div className="measure-cell measunits border-bottom">Unit</div>
                            </div>
                            <div className="measure-rows">
                                <div className="measure-cell px-2">Total</div>
                                <div className="measure-cell numberright font-sarabun">{ReadTags_Thounsand(data.energy_active_total, 1)}</div>
                                <div className="measure-cell measunits">kWh</div>
                            </div>
                            <div className="measure-rows">
                                <div className="measure-cell px-2">Today</div>
                                <div className="measure-cell numberright font-sarabun">{ReadTags_Thounsand(data.energy_active_total_today, 1)}</div>
                                <div className="measure-cell measunits">kWh</div>
                            </div>
                            <div className="measure-rows">
                                <div className="measure-cell px-2">Power</div>
                                <div className="measure-cell numberright font-sarabun">{ReadTags_Thounsand(data.ac_power_active_total, 1)}</div>
                                <div className="measure-cell measunits">kW</div>
                            </div>
                            <div className="measure-rows">
                                <div className="measure-cell px-2">V L12</div>
                                <div className="measure-cell numberright font-sarabun">{ReadTags_Thounsand(data.ac_voltage_l12, 1)}</div>
                                <div className="measure-cell measunits">Volt</div>
                            </div>
                            <div className="measure-rows">
                                <div className="measure-cell px-2">V L23</div>
                                <div className="measure-cell numberright font-sarabun">{ReadTags_Thounsand(data.ac_voltage_l23, 1)}</div>
                                <div className="measure-cell measunits">Volt</div>
                            </div>
                            <div className="measure-rows">
                                <div className="measure-cell px-2">V L31</div>
                                <div className="measure-cell numberright font-sarabun">{ReadTags_Thounsand(data.ac_voltage_l31, 1)}</div>
                                <div className="measure-cell measunits">Volt</div>
                            </div>
                            <div className="measure-rows">
                                <div className="measure-cell px-2">I L1</div>
                                <div className="measure-cell numberright font-sarabun">{ReadTags_Thounsand(data.ac_current_l1, 1)}</div>
                                <div className="measure-cell measunits">A.</div>
                            </div>
                            <div className="measure-rows">
                                <div className="measure-cell px-2">I L2</div>
                                <div className="measure-cell numberright font-sarabun">{ReadTags_Thounsand(data.ac_current_l2, 1)}</div>
                                <div className="measure-cell measunits">A.</div>
                            </div>
                            <div className="measure-rows">
                                <div className="measure-cell px-2">I L3</div>
                                <div className="measure-cell numberright font-sarabun">{ReadTags_Thounsand(data.ac_current_l3, 1)}</div>
                                <div className="measure-cell measunits">A.</div>
                            </div>
                            <div className="measure-rows">
                                <div className="measure-cell px-2">PF</div>
                                <div className="measure-cell numberright font-sarabun">{ReadTags(data.power_factor, 1)}</div>
                                <div className="measure-cell measunits"></div>
                            </div>
                            <div className="measure-rows">
                                <div className="measure-cell px-2">Freq.</div>
                                <div className="measure-cell numberright font-sarabun">{ReadTags(data.frequency, 1)}</div>
                                <div className="measure-cell measunits">Hz.</div>
                            </div>
                            <div className="measure-rows">
                                <div className="measure-cell px-2">Inverter State</div>
                                <div className="measure-cell numberright font-sarabun">{ReadTags(data.inverter_state, 0)}</div>
                                <div className="measure-cell measunits"></div>
                            </div>
                        </div>
                    </div>
                    <p className='see-more mt-0 mb-0'>Click to see more parameter.</p>
                </div>
            </div>
        </div >
    )
}
